import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "overview-panel" }
const _hoisted_2 = {
  key: 0,
  class: "kpi-row"
}
const _hoisted_3 = { class: "kpi-card" }
const _hoisted_4 = { class: "kpi-value" }
const _hoisted_5 = { class: "kpi-card" }
const _hoisted_6 = { class: "kpi-value" }
const _hoisted_7 = { class: "kpi-card kpi-card--success" }
const _hoisted_8 = { class: "kpi-value" }
const _hoisted_9 = { class: "kpi-card kpi-card--warning" }
const _hoisted_10 = { class: "kpi-value" }
const _hoisted_11 = { class: "kpi-value" }
const _hoisted_12 = { class: "kpi-card" }
const _hoisted_13 = { class: "kpi-value" }
const _hoisted_14 = {
  key: 1,
  class: "kpi-row"
}
const _hoisted_15 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_16 = {
  key: 4,
  class: "project-grid"
}
const _hoisted_17 = ["onClick", "onKeydown"]
const _hoisted_18 = { class: "project-main" }
const _hoisted_19 = { class: "project-left" }
const _hoisted_20 = { class: "project-title" }
const _hoisted_21 = { class: "item-meta" }
const _hoisted_22 = { class: "item-meta" }
const _hoisted_23 = { class: "item-meta" }
const _hoisted_24 = { class: "gauge-wrap" }
const _hoisted_25 = { class: "gauge-shell" }
const _hoisted_26 = {
  viewBox: "0 0 200 120",
  class: "gauge-svg",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "gauge-value" }
const _hoisted_28 = { class: "gauge-legend" }
const _hoisted_29 = { class: "project-right" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = {
  key: 1,
  class: "project-photo project-photo-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonBlock = _resolveComponent("SkeletonBlock")!
  const _component_SkeletonList = _resolveComponent("SkeletonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.kpi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.kpi.activeProjects), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "kpi-label" }, "Projetos ativos", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.kpi.totalTasks), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "kpi-label" }, "Tarefas total", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.kpi.completedTasks), 1),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "kpi-label" }, "Concluídas", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.kpi.inProgressTasks), 1),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "kpi-label" }, "Em andamento", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["kpi-card", _ctx.kpi.overdueTasks > 0 ? 'kpi-card--danger' : ''])
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.kpi.overdueTasks), 1),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "kpi-label" }, "Atrasadas", -1))
          ], 2),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.kpi.teamMembers), 1),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "kpi-label" }, "Equipe", -1))
          ])
        ]))
      : (_ctx.kpiLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "kpi-card kpi-card--skeleton"
              }, [
                _createVNode(_component_SkeletonBlock, {
                  width: "36px",
                  height: "24px"
                }),
                _createVNode(_component_SkeletonBlock, {
                  width: "70%",
                  height: "10px"
                })
              ])
            }), 64))
          ]))
        : _createCommentVNode("", true),
    (_ctx.showProjectsSkeleton)
      ? (_openBlock(), _createBlock(_component_SkeletonList, {
          key: 2,
          variant: "card",
          count: 3
        }))
      : (_ctx.projects.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "empty-text" }, "Nenhum projeto cadastrado.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
              return (_openBlock(), _createElementBlock("article", {
                key: proj.id,
                class: "project-card clickable-card",
                role: "button",
                tabindex: "0",
                onClick: ($event: any) => (_ctx.$emit('extend-project', proj.id)),
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (_ctx.$emit('extend-project', proj.id)), ["prevent"]), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (_ctx.$emit('extend-project', proj.id)), ["prevent"]), ["space"])
                ]
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h3", _hoisted_20, _toDisplayString(proj.name), 1),
                    _createElementVNode("div", _hoisted_21, "Responsável: " + _toDisplayString(_ctx.leadResponsible(proj)), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[7] || (_cache[7] = _createTextVNode(" Status: ", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.insightFor(proj.id).status === 'atrasado' ? 'status-late' : 'status-ok')
                      }, _toDisplayString(_ctx.insightFor(proj.id).status === 'atrasado' ? 'Atrasado' : 'Em dia'), 3)
                    ]),
                    _createElementVNode("div", _hoisted_23, "Previsão de conclusão: " + _toDisplayString(_ctx.forecastText(proj.id)), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_26, [
                          _cache[8] || (_cache[8] = _createElementVNode("path", {
                            class: "gauge-track",
                            d: "M20 100 A80 80 0 0 1 180 100",
                            pathLength: "100"
                          }, null, -1)),
                          _createElementVNode("path", {
                            class: "gauge-planned",
                            d: "M20 100 A80 80 0 0 1 180 100",
                            pathLength: "100",
                            style: _normalizeStyle(_ctx.arcStyle(_ctx.insightFor(proj.id).plannedPercent))
                          }, null, 4),
                          _createElementVNode("path", {
                            class: "gauge-actual",
                            d: "M20 100 A80 80 0 0 1 180 100",
                            pathLength: "100",
                            style: _normalizeStyle(_ctx.arcStyle(_ctx.insightFor(proj.id).actualPercent))
                          }, null, 4)
                        ])),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.percentText(_ctx.insightFor(proj.id).actualPercent)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "dot dot-planned" }, null, -1)),
                          _createTextVNode("Planejado " + _toDisplayString(_ctx.percentText(_ctx.insightFor(proj.id).plannedPercent)), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "dot dot-actual" }, null, -1)),
                          _createTextVNode("Real " + _toDisplayString(_ctx.percentText(_ctx.insightFor(proj.id).actualPercent)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.hasPhoto(proj.photoDataUrl))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "project-photo",
                          src: _ctx.photoSrc(proj.photoDataUrl),
                          alt: proj.name
                        }, null, 8, _hoisted_30))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, "Sem foto"))
                  ])
                ])
              ], 40, _hoisted_17))
            }), 128))
          ]))
  ]))
}